import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';
import { CATEGORIES } from './constants';

class HomeStore extends EventDrivenStore {
  constructor() {
    console.log('[HomeStore] Initializing HomeStore');
    super('home', {
      recommended: {
        dishes: [],
        loading: false,
        error: null
      },
      nearby: {
        dishes: [],
        loading: false,
        error: null
      },
      popularRestaurants: {
        restaurants: [],
        loading: false,
        error: null
      },
      newRestaurants: {
        restaurants: [],
        loading: false,
        error: null
      },
      categories: {
        items: CATEGORIES,
        loading: false,
        error: null
      },
      ads: {
        items: [],
        loading: false,
        error: null
      },
      coupons: {
        items: [],
        loading: false,
        error: null
      },
      sponsorships: {
        items: [],
        loading: false,
        error: null
      },
      allRestaurants: {
        restaurants: [],
        loading: false,
        error: null
      },
      deals: {
        items: [],
        loading: false,
        error: null
      }
    });

    console.log('[HomeStore] Initial state set up');
    this.setupEvents();
    console.log('[HomeStore] HomeStore initialized successfully');
  }

  setupEvents() {
    console.log('[HomeStore] Setting up event listeners');

    // ============ NEARBY DISHES EVENTS ============
    this.on(constants.EVENTS.HOME.NEARBY_LOADING, () => {
      console.log('[HomeStore] NEARBY_LOADING event received');
      this.state.nearby.loading = true;
      this.state.nearby.error = null;
      console.log('[HomeStore] NEARBY loading state updated');
    });

    this.on(constants.EVENTS.HOME.NEARBY_LOADED, (data) => {
      console.log('[HomeStore] NEARBY_LOADED event received with data:', data);
      this.state.nearby.dishes = Array.isArray(data) ? data : [];
      this.state.nearby.loading = false;
      this.state.nearby.error = null;
      console.log('[HomeStore] NEARBY state updated:', {
        count: this.state.nearby.dishes.length,
        loading: this.state.nearby.loading,
        error: this.state.nearby.error
      });
    });

    this.on(constants.EVENTS.HOME.NEARBY_LOAD_ERROR, (error) => {
      console.error('[HomeStore] NEARBY_LOAD_ERROR event received:', error);
      this.state.nearby.loading = false;
      this.state.nearby.error = error?.message || error;
      this.state.nearby.dishes = [];
    });

    // ============ RECOMMENDED DISHES EVENTS ============
    this.on(constants.EVENTS.HOME.RECOMMENDED_LOADING, () => {
      console.log('[HomeStore] RECOMMENDED_LOADING event received');
      this.state.recommended.loading = true;
      this.state.recommended.error = null;
      console.log('[HomeStore] recommended loading state updated');
    });

    this.on(constants.EVENTS.HOME.RECOMMENDED_LOADED, (data) => {
      console.log('[HomeStore] RECOMMENDED_LOADED event received with data:', data);
      this.state.recommended.dishes = Array.isArray(data) ? data : [];
      this.state.recommended.loading = false;
      this.state.recommended.error = null;
      console.log('[HomeStore] recommended state updated:', {
        count: this.state.recommended.dishes.length,
        loading: this.state.recommended.loading,
        error: this.state.recommended.error
      });
    });

    this.on(constants.EVENTS.HOME.RECOMMENDED_LOAD_ERROR, (error) => {
      console.error('[HomeStore] RECOMMENDED_LOAD_ERROR event received:', error);
      this.state.recommended.loading = false;
      this.state.recommended.error = error?.message || error;
      this.state.recommended.dishes = [];
    });

    // ============ POPULAR RESTAURANTS EVENTS ============
    this.on(constants.EVENTS.HOME.POPULAR_RESTAURANTS_LOADING, () => {
      console.log('[HomeStore] POPULAR_RESTAURANTS_LOADING event received');
      this.state.popularRestaurants.loading = true;
      this.state.popularRestaurants.error = null;
      console.log('[HomeStore] Popular restaurants loading state updated');
    });

    this.on(constants.EVENTS.HOME.POPULAR_RESTAURANTS_LOADED, (data) => {
      console.log('[HomeStore] POPULAR_RESTAURANTS_LOADED event received with data:', data);
      this.state.popularRestaurants.restaurants = Array.isArray(data) ? data : [];
      this.state.popularRestaurants.loading = false;
      this.state.popularRestaurants.error = null;
      console.log('[HomeStore] Popular restaurants state updated:', {
        count: this.state.popularRestaurants.restaurants.length,
        loading: this.state.popularRestaurants.loading,
        error: this.state.popularRestaurants.error
      });
    });

    this.on(constants.EVENTS.HOME.POPULAR_RESTAURANTS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] POPULAR_RESTAURANTS_LOAD_ERROR event received:', error);
      this.state.popularRestaurants.loading = false;
      this.state.popularRestaurants.error = error?.message || error;
      this.state.popularRestaurants.restaurants = [];
    });

    // ============ NEW RESTAURANTS EVENTS ============
    this.on(constants.EVENTS.HOME.NEW_RESTAURANTS_LOADING, () => {
      console.log('[HomeStore] NEW_RESTAURANTS_LOADING event received');
      this.state.newRestaurants.loading = true;
      this.state.newRestaurants.error = null;
      console.log('[HomeStore] New restaurants loading state updated');
    });

    this.on(constants.EVENTS.HOME.NEW_RESTAURANTS_LOADED, (data) => {
      console.log('[HomeStore] NEW_RESTAURANTS_LOADED event received with data:', data);
      this.state.newRestaurants.restaurants = Array.isArray(data) ? data : [];
      this.state.newRestaurants.loading = false;
      this.state.newRestaurants.error = null;
      console.log('[HomeStore] New restaurants state updated:', {
        count: this.state.newRestaurants.restaurants.length,
        loading: this.state.newRestaurants.loading,
        error: this.state.newRestaurants.error
      });
    });

    this.on(constants.EVENTS.HOME.NEW_RESTAURANTS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] NEW_RESTAURANTS_LOAD_ERROR event received:', error);
      this.state.newRestaurants.loading = false;
      this.state.newRestaurants.error = error?.message || error;
      this.state.newRestaurants.restaurants = [];
    });

    // ============ CATEGORIES EVENTS ============
    this.on(constants.EVENTS.HOME.CATEGORIES_LOADING, () => {
      console.log('[HomeStore] CATEGORIES_LOADING event received');
      this.state.categories.loading = true;
      this.state.categories.error = null;
      console.log('[HomeStore] Categories loading state updated');
    });

    this.on(constants.EVENTS.HOME.CATEGORIES_LOADED, (data) => {
      console.log('[HomeStore] CATEGORIES_LOADED event received with data:', data);
      this.state.categories.items = Array.isArray(data) ? data : CATEGORIES;
      this.state.categories.loading = false;
      this.state.categories.error = null;
      console.log('[HomeStore] Categories state updated:', {
        count: this.state.categories.items.length,
        loading: this.state.categories.loading,
        error: this.state.categories.error
      });
    });

    this.on(constants.EVENTS.HOME.CATEGORIES_LOAD_ERROR, (error) => {
      console.error('[HomeStore] CATEGORIES_LOAD_ERROR event received:', error);
      this.state.categories.loading = false;
      this.state.categories.error = error?.message || error;
      this.state.categories.items = CATEGORIES;
    });

    // ============ ADS EVENTS ============
    this.on(constants.EVENTS.HOME.ADS_LOADING, () => {
      console.log('[HomeStore] ADS_LOADING event received');
      this.state.ads.loading = true;
      this.state.ads.error = null;
      console.log('[HomeStore] Ads loading state updated');
    });

    this.on(constants.EVENTS.HOME.ADS_LOADED, (data) => {
      console.log('[HomeStore] ADS_LOADED event received with data:', data);
      this.state.ads.items = Array.isArray(data) ? data : [];
      this.state.ads.loading = false;
      this.state.ads.error = null;
      console.log('[HomeStore] Ads state updated:', {
        count: this.state.ads.items.length,
        loading: this.state.ads.loading,
        error: this.state.ads.error
      });
    });

    this.on(constants.EVENTS.HOME.ADS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] ADS_LOAD_ERROR event received:', error);
      this.state.ads.loading = false;
      this.state.ads.error = error?.message || error;
      this.state.ads.items = [];
    });

    // ============ COUPONS EVENTS ============
    this.on(constants.EVENTS.HOME.COUPONS_LOADING, () => {
      console.log('[HomeStore] COUPONS_LOADING event received');
      this.state.coupons.loading = true;
      this.state.coupons.error = null;
      console.log('[HomeStore] Coupons loading state updated');
    });

    this.on(constants.EVENTS.HOME.COUPONS_LOADED, (data) => {
      console.log('[HomeStore] COUPONS_LOADED event received with data:', data);
      this.state.coupons.items = Array.isArray(data) ? data : [];
      this.state.coupons.loading = false;
      this.state.coupons.error = null;
      console.log('[HomeStore] Coupons state updated:', {
        count: this.state.coupons.items.length,
        loading: this.state.coupons.loading,
        error: this.state.coupons.error
      });
    });

    this.on(constants.EVENTS.HOME.COUPONS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] COUPONS_LOAD_ERROR event received:', error);
      this.state.coupons.loading = false;
      this.state.coupons.error = error?.message || error;
      this.state.coupons.items = [];
    });

    // ============ SPONSORSHIPS EVENTS ============
    this.on(constants.EVENTS.HOME.SPONSORSHIPS_LOADING, () => {
      console.log('[HomeStore] SPONSORSHIPS_LOADING event received');
      this.state.sponsorships.loading = true;
      this.state.sponsorships.error = null;
    });

    this.on(constants.EVENTS.HOME.SPONSORSHIPS_LOADED, (data) => {
      console.log('[HomeStore] SPONSORSHIPS_LOADED event received with data:', data);
      this.state.sponsorships.items = Array.isArray(data) ? data : [];
      this.state.sponsorships.loading = false;
      this.state.sponsorships.error = null;
      console.log('[HomeStore] Sponsorships state updated:', {
        count: this.state.sponsorships.items.length,
        loading: this.state.sponsorships.loading,
        error: this.state.sponsorships.error
      });
    });

    this.on(constants.EVENTS.HOME.SPONSORSHIPS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] SPONSORSHIPS_LOAD_ERROR event received:', error);
      this.state.sponsorships.loading = false;
      this.state.sponsorships.error = error?.message || error;
      this.state.sponsorships.items = [];
    });

    // ============ ALL RESTAURANTS EVENTS ============
    this.on(constants.EVENTS.HOME.ALL_RESTAURANTS_LOADING, () => {
      this.state.allRestaurants.loading = true;
      this.state.allRestaurants.error = null;
    });

    this.on(constants.EVENTS.HOME.ALL_RESTAURANTS_LOADED, (data) => {
      this.state.allRestaurants.restaurants = Array.isArray(data) ? data : [];
      this.state.allRestaurants.loading = false;
    });

    this.on(constants.EVENTS.HOME.ALL_RESTAURANTS_LOAD_ERROR, (error) => {
      this.state.allRestaurants.loading = false;
      this.state.allRestaurants.error = error?.message || error;
      this.state.allRestaurants.restaurants = [];
    });

    // ============ DEALS EVENTS ============
    this.on(constants.EVENTS.HOME.DEALS_LOADING, () => {
      console.log('[HomeStore] DEALS_LOADING event received');
      this.state.deals.loading = true;
      this.state.deals.error = null;
      console.log('[HomeStore] Deals loading state updated');
    });

    this.on(constants.EVENTS.HOME.DEALS_LOADED, (data) => {
      console.log('[HomeStore] DEALS_LOADED event received with data:', data);
      this.state.deals.items = Array.isArray(data) ? data : [];
      this.state.deals.loading = false;
      this.state.deals.error = null;
      console.log('[HomeStore] Deals state updated:', {
        count: this.state.deals.items.length,
        loading: this.state.deals.loading,
        error: this.state.deals.error
      });
    });

    this.on(constants.EVENTS.HOME.DEALS_LOAD_ERROR, (error) => {
      console.error('[HomeStore] DEALS_LOAD_ERROR event received:', error);
      this.state.deals.loading = false;
      this.state.deals.error = error?.message || error;
      this.state.deals.items = [];
    });

    console.log('[HomeStore] All event listeners set up successfully');
  }

  // Getters
  get featuredDishes() {
    return this.state.nearby.dishes;
  }

  get popularRestaurants() {
    return this.state.popularRestaurants.restaurants;
  }

  get newRestaurants() {
    return this.state.newRestaurants.restaurants;
  }

  get categories() {
    return this.state.categories.items;
  }

  get ads() {
    return this.state.ads.items;
  }

  get sponsorships() {
    return this.state.sponsorships.items;
  }

  get allRestaurants() {
    return this.state.allRestaurants.restaurants;
  }

  get deals() {
    return this.state.deals.items;
  }

  // Restaurants recommandés (ceux avec note > 4.0 ou tag recommended)
  get recommendedRestaurants() {
    return this.state.nearby.dishes.filter(r =>
      r.isRecommended || (r.rating && r.rating >= 4.0)
    ).slice(0, 5);
  }

  // Restaurants avec deals/promotions
  get dealRestaurants() {
    return this.state.nearby.dishes.filter(r =>
      r.discount || r.hasDeal
    ).slice(0, 5);
  }

  // Restaurants proches (avec distance)
  get nearbyRestaurants() {
    return this.state.nearby.dishes
      .filter(r => r.distance)
      .sort((a, b) => (a.distance || 0) - (b.distance || 0))
      .slice(0, 5);
  }

  get isLoading() {
    return this.state.nearby.loading || this.state.popularRestaurants.loading ||
           this.state.categories.loading || this.state.sponsorships.loading ||
           this.state.deals.loading;
  }

  get hasError() {
    return !!(this.state.nearby.error || this.state.popularRestaurants.error ||
              this.state.categories.error || this.state.sponsorships.error);
  }
}

export default HomeStore;
